import { observer } from 'mobx-react';
import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text, TextButton } from '@wix/design-system';
import { Experiments, PaymentCycle } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import s from '../Cycles/Cycles.scss';

interface DisclaimerFooterProps {
  rootStore: RootStore;
}

const DisclaimerFooterComp: React.FC<DisclaimerFooterProps> = ({
  rootStore,
}) => {
  const { setCurrentCycle, experiments, isEligibleForRevShare } = rootStore.appStore;

  let cyclesDisclaimerFooter = experiments[Experiments.EnableImmediateCouponsDeliverySpec] === 'true' ?
    'premium-purchase-plan.cycle_selection.monthly_warning.switch_cycle_footer'
    : 'cycle_entry.monthly_disclaimer.footer';

  if (isEligibleForRevShare) {
    cyclesDisclaimerFooter = 'cycle_entry.monthly_disclaimer_revshare.footer';
  }

  return (
    <Text
      tagName='div'
      weight='normal'
      size='small'
      dataHook='monthly-disclaimer-missing-features'
      className={s.monthlyDisclaimerFooter}
    >
      <Trans i18nKey={cyclesDisclaimerFooter}>
        Choose a
        <TextButton
          as='a'
          dataHook='select-yearly'
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            return setCurrentCycle({ cycle: PaymentCycle.YEARLY });
          }}
          size='small'
          underline='onHover'
          weight='normal'
        >
          yearly
        </TextButton>
        or
        <TextButton
          as='a'
          dataHook='select-multiyearly'
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            setCurrentCycle({ cycle: PaymentCycle.YEAR2 });
          }}
          size='small'
          underline='onHover'
          weight='normal'
        >
          multi-year
        </TextButton>
        subscription to get the most from your premium plan.
      </Trans>
    </Text>
  );
};

export const DisclaimerFooter = withInjectedRootStore(
  observer(DisclaimerFooterComp),
);
